import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/font/iconfont.css";
import "../src/utils/Public";
import $axios from "./utils/Ajax.js";
import $Help from "./utils/PublicFun";
import { sha256 } from "js-sha256";
Vue.prototype.$sha256 = sha256;

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$axios = $axios;
Vue.prototype.$Help = $Help.QMdata; //参数签名
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
